/** The public menu (today's LandingPage/navConfig.ts, mirrored here because src/next cannot import old code). Keys are today's landing_nav keys. */
export const SITE_TABS = [
  { key: "home", path: "/" }, { key: "vision", path: "/vision" }, { key: "partnership", path: "/partnership" },
  { key: "platform", path: "/platform" }, { key: "team", path: "/team" }, { key: "testimonials", path: "/testimonials" },
] as const;
export const SITE_DONATE = { key: "donate", path: "/donate" } as const;
export const SITE_CONTACT = { key: "contact_us", path: "/contact-us" } as const;
